import React from 'react';


const SuitCaseIcon = (props) => {

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.5 10.375L10.8375 11.43C11.6098 11.5216 12.3902 11.5216 13.1625 11.43L21.5 10.375" stroke={props.strokeColor} strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M15.5 6.5V5.15125C15.5 4.23 15.0237 3.5 14.0212 3.5H9.955C8.95125 3.5 8.5 4.23 8.5 5.13625V6.5" stroke={props.strokeColor} strokeWidth="1.2" strokeLinejoin="round" />
      <rect x="2.5" y="6.5" width="19" height="15" rx="2" stroke={props.strokeColor} strokeWidth="1.2" strokeLinejoin="round" />
      <circle cx="12" cy="14" r="0.5" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="14" r="0.3125" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="14" r="0.125" stroke={props.strokeColor} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default SuitCaseIcon